import { Component, ElementRef, Inject, OnInit, PLATFORM_ID, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { Meetup, MiteventsService } from '../../mitevents.service';
import { Constants } from '../../common/constants';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ThankYouPopupComponent } from '../thank-you-popup/thank-you-popup.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import * as AOS from 'aos';

import {
  trigger, state, style, animate, transition, query, group
} from '@angular/animations';
import { MatAccordion } from '@angular/material/expansion';
import { isPlatformBrowser, ViewportScroller } from '@angular/common';
interface GalleryImage {
  id: number;
  imageUrl: string;
}
@Component({
  selector: 'app-single-event',
  templateUrl: './single-event.component.html',
  styleUrls: ['./single-event.component.css'],
  animations: [
    trigger('fade', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate(1000, style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate(1000, style({ opacity: 0 }))
      ])
    ])
  ]
})
export class SingleEventComponent implements OnInit {
  eventId !: number;
  event!: Meetup;
  showEvents: boolean = false;
  form!: FormGroup;
  isSubmitting: boolean = false;
  thankYouVisible: boolean = true;
  dialogRef!: MatDialogRef<ThankYouPopupComponent>;
  selectedFile!: File;
  today = new Date();
  pageUrl:string="";
  currentUrl !: string;
  isPastEvent!:boolean;
  galleryImages: GalleryImage[] = [];

  separateDialCode = true;
  isBrowser:boolean=false;


  @ViewChild(MatAccordion) accordion !: MatAccordion;
  constructor(
    private route: ActivatedRoute,private el: ElementRef, private renderer: Renderer2,private router: Router, private viewportScroller: ViewportScroller,
    private eventService: MiteventsService,  @Inject(PLATFORM_ID) private platformId: any,
 private fb: FormBuilder, private http: HttpClient, private dialog: MatDialog
  ) {this.isBrowser=isPlatformBrowser(this.platformId); }

  ngOnInit() {
    this.currentUrl = this.router.url; 
    this.route.params.subscribe(params => {
      this.eventId = params['id'];
      this.fetchEventDetails();
    });

    this.form = this.fb.group({

      Name: ['', [Validators.required, this.customNameValidator()]],
      College: ['', [Validators.required, this.customNameValidator()]],
      Qualification: ['', [Validators.required, Validators.pattern(/^[a-zA-Z ]*$/)]],
      Email: ['', [Validators.required, this.customEmailValidator()]],
      Phone: ['', [Validators.required, this.customPhoneValidator()]],
      position: [''],
      company: [''],
      meetUpId: this.eventId
    });
if(this.isBrowser){     
  AOS.init({disable: 'mobile', duration: 2000, delay: 500,});
}
   
const inputElemnt=document.getElementById('#phone');


  }
  scrollToSection(sectionId: string): void {
    this.viewportScroller.scrollToAnchor(sectionId);
  }

  fetchEventDetails() {
    this.eventService.getMeetupById(this.eventId).subscribe(event => {
      this.event = event;
      this.showEvents = true;
      this.galleryImages = event.meetUpGalleryImages.map((img:any) => ({
        id: img.id,
        imageUrl: img.imageUrl
      }));
      this.splitEvent();
    });
  }
  navigateToEventForm() {
    let navigationExtras: NavigationExtras = {
      fragment: 'eventForm'
    };
    this.router.navigate([this.currentUrl], navigationExtras);
  }
  splitEvent() {
    const today = new Date(); // Get today's date
    today.setHours(0, 0, 0, 0); // Set to midnight to compare only the date part
  
    const startDate = new Date(this.event.startDate); // Convert event start date to Date object
    startDate.setHours(0, 0, 0, 0); // Set to midnight to compare only the date part
  
    if (startDate < today) {
      // If event start date is before today, set isPastEvent to true and isRegisterable to false
      this.isPastEvent = true;
     
    } else {
      // If event start date is today or after, set isPastEvent to false and isRegisterable to true
      this.isPastEvent = false;
     
    }
  }
  // getBannerImage(): string {
  //   return this.event.images.length ? this.getImagePath(this.event.images[0].path) : 'path/to/default/banner.jpg';
  // }

  getImagePath(relativePath: string): string {
    return Constants.baseUrl + `/` + `${relativePath}`;
  }
  getImageUrl(bannerImage:string){
    if(bannerImage!=null){
    
    return Constants.baseImageUrl + bannerImage;
    }else{
      return '../../../assets/images/InternshipPage/business-conference-banner-template-design-for-webinar-marketing-online-class-program-etc-free-vector.jpg'
    }
      }
  onFileChanged(event: any) {
    this.selectedFile = event.target.files[0];
  }
  submitted = false; 
  onSubmit(): void {
    this.submitted = true; 
    // Check if the form is valid
    if (this.form.invalid) {
      return;
    }
    // Disable the submit button while processing
    this.isSubmitting = true;
    const uploadData = new FormData();
    // console.log(this.form.value);
    uploadData.append('Name', this.form.get('Name')!.value);
    uploadData.append('College', this.form.get('College')!.value);
    uploadData.append('Qualification', this.form.get('Qualification')!.value);
    uploadData.append('Email', this.form.get('Email')!.value);
    uploadData.append('Phone', this.form.get('Phone')!.value);
  


    this.http.post(Constants.baseUrl+'/api/Enrollment/eventRegistrationData/'+this.eventId, uploadData)

      .subscribe(
        (response: any) => {
          this.form.reset();
          this.isSubmitting = false;
          this.dialogRef = this.dialog.open(ThankYouPopupComponent);

          setTimeout(() => {
            // this.thankYouVisible = false;
            this.dialogRef.close();
          }, 5000);
        },
        (error) => {
          // console.error('Error:', error);
          this.isSubmitting = false;
        }
      );
  }
  // Utility function to handle form validation
  isFormControlInvalid(controlName: string): boolean {
    const control = this.form.get(controlName);
    if (control) {
      return control.invalid && (control.dirty || control.touched|| this.submitted );
    }
    return false;
  }

  // Function to get the error message for a specific control
  getErrorMessage(controlName: string): string {
    const control = this.form.get(controlName);
    if (control?.hasError('required')) {
      return `${controlName.replace('input', '')} is required.`;
    } else if (control?.hasError('emptyName')) {
      return 'Name cannot be empty.';
    } else if (control?.hasError('invalidName')) {
      return 'Name can accept spaces, alphabets, and hyphens only.';
    } else if (control?.hasError('emptyEmail')) {
      return 'Email is required.';
    } else if (control?.hasError('invalidEmail')) {
      return 'Enter a valid business email.';
    } else if (control?.hasError('emptyPhone')) {
      return 'Phone number is required.';
    } else if (control?.hasError('invalidPhone')) {
      return 'Enter a valid phone number.';
    } else {
      return '';
    }
  }

  // Custom validator for the name input
  customNameValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return { emptyName: true }; // Name is empty
      }
      if (!/^[a-zA-Z ]*$/.test(control.value)) {
        return { invalidName: true }; // Invalid characters in name
      }
      return null;
    };
  }

  // Custom validator for email input
  customEmailValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return { emptyEmail: true }; // Email is empty
      }
      if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(control.value)) {
        return { invalidEmail: true }; // Invalid email format
      }
      return null;
    };
  }
  onFileChange(event: any) {
    if (event.target.files[0].length > 0) {
      const file = event.target.files[0];
      this.form.patchValue({
        attachment: file
      });
    }
  }

  // Custom validator for phone number input
  customPhoneValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return { emptyPhone: true }; // Phone number is empty
      }
      if (!/^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/.test(control.value)) {
        return { invalidPhone: true }; // Invalid phone number
      }
      return null;
    };
  }
  @ViewChild('empSwiperContainer', { static: false }) empSwiperContainer!: ElementRef;
  @ViewChild('overlay', { static: false }) overlay!: ElementRef<HTMLDivElement>;
  @ViewChild('image', { static: false }) image!: ElementRef<HTMLImageElement>;

  showOverlay = false;
  imageSrc = '';
  openLightbox(imageSrc: string): void {
    this.imageSrc = this.getImageUrl(imageSrc);
    this.showOverlay = true;
  }

  closeLightbox(): void {
    this.showOverlay = false;
  }

  showNextImage(): void {
    const currentIndex = this.galleryImages.findIndex(img => img.imageUrl === this.imageSrc);
    const nextIndex = (currentIndex + 1) % this.galleryImages.length;
    this.imageSrc = this.getImageUrl(this.galleryImages[nextIndex].imageUrl);
  }

  showPrevImage(): void {
    const currentIndex = this.galleryImages.findIndex(img => img.imageUrl === this.imageSrc);
    const prevIndex = (currentIndex - 1 + this.galleryImages.length) % this.galleryImages.length;
    this.imageSrc = this.getImageUrl(this.galleryImages[prevIndex].imageUrl);
  }
  ngAfterViewInit() {
    if(this.isBrowser){  
    const swiperElements=this.empSwiperContainer.nativeElement;
    const shadowRoots=swiperElements.shadowRoot;
  if(shadowRoots){
     const page=shadowRoots.querySelector('.swiper-pagination')
     if(page){
       this.renderer.setStyle(page, 'position', 'unset');  
     }
     else{
      //  console.error('Pagination element not found in shadow root');
     }
    }else{
    
    //  console.error('Shadow root not found');
    }
  

  
    

   // Ensure swiperContainer is available
   if(shadowRoots){
     const paginationElement = shadowRoots.querySelector('.swiper-pagination');
     if (paginationElement) {
       // Apply styles to the pagination bullets        
         this.renderer.setStyle(paginationElement, 'position', 'unset');          
     } else {
      //  console.error('Pagination element not found in shadow root');
     }
   }else {
    //  console.error('Shadow root not found');
   }


}
}


}
